<h2 mat-dialog-title><mat-icon>description</mat-icon> Новый договор с поставщиком</h2>
<form [formGroup]="form" (ngSubmit)="save()" [attr.aria-busy]="saving">
  <mat-dialog-content>
    <div class="info" *ngIf="data?.lockContext">
      <div><span>Поставщик</span><strong>{{ data.provider?.description }}</strong></div>
      <div><span>Организация</span><strong>{{ data.org?.name }}</strong></div>
    </div>
    <div class="fields">
      <ng-container *ngIf="!data?.lockContext">
        <div class="contextField">
          <app-provider-selector [control]="providerControl" [showCreateButton]="true"></app-provider-selector>
          <span class="fieldError" *ngIf="providerControl.touched && providerControl.invalid">Выберите поставщика из списка</span>
        </div>
        <div class="contextField">
          <app-org-selector [control]="orgControl"></app-org-selector>
          <span class="fieldError" *ngIf="orgControl.touched && orgControl.invalid">Выберите организацию из списка</span>
        </div>
      </ng-container>
      <mat-form-field appearance="outline" floatLabel="always" class="wide">
        <mat-label>Номер договора</mat-label>
        <input matInput formControlName="number" placeholder="Без номера" maxlength="255" autocomplete="off" />
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Действует с</mat-label>
        <input matInput [matDatepicker]="startPicker" formControlName="start_date" required />
        <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
        <mat-error>Укажите корректную дату начала</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Действует до</mat-label>
        <input matInput [matDatepicker]="endPicker" [min]="form.controls.start_date.value" formControlName="end_date" placeholder="Без срока" />
        <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
        <mat-error>Дата окончания не раньше начала</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Отсрочка, дней</mat-label>
        <input matInput type="number" min="0" step="1" formControlName="day_limit" />
        <mat-error>Укажите целое число от 0</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Кредитный лимит, грн</mat-label>
        <input matInput type="number" min="0" step="0.01" formControlName="credit_limit" />
        <mat-error>Укажите сумму от 0</mat-error>
      </mat-form-field>
      <mat-checkbox formControlName="active" class="wide">Договор активен</mat-checkbox>
    </div>
    <p *ngIf="form.hasError('dateOrder')" class="error" role="alert">Дата окончания не может быть раньше начала.</p>
    <p *ngIf="error" class="error" role="alert">{{ error }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-stroked-button type="button" (click)="close()" [disabled]="saving">Отмена</button>
    <button mat-flat-button color="primary" type="submit" [disabled]="saving || form.invalid">
      <mat-spinner *ngIf="saving" diameter="18" strokeWidth="2"></mat-spinner>
      <mat-icon *ngIf="!saving">add</mat-icon>
      {{ saving ? 'Создаём…' : 'Создать договор' }}
    </button>
  </mat-dialog-actions>
</form>
